var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"character-counter",class:_vm.counterClass},[_c('span',{staticClass:"counter-text"},[_vm._v(" "+_vm._s(_vm.current)+"/"+_vm._s(_vm.max)+" ")]),(_vm.showWarning && _vm.remaining <= _vm.warningThreshold)?_c('span',{staticClass:"warning-text"},[_vm._v(" 还剩 "+_vm._s(_vm.remaining)+" 个字符 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }